var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnImageDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#141415"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46447 11.4901C5.15616 11.7984 5.15616 12.2983 5.46447 12.6066C5.77277 12.9149 6.27264 12.9149 6.58095 12.6066L9 10.1876L11.419 12.6066C11.7274 12.9149 12.2272 12.9149 12.5355 12.6066C12.8438 12.2983 12.8438 11.7984 12.5355 11.4901L10.1165 9.07107L12.5355 6.65202C12.8438 6.34371 12.8438 5.84384 12.5355 5.53553C12.2272 5.22722 11.7274 5.22722 11.419 5.53553L9 7.95458L6.58095 5.53553C6.27264 5.22723 5.77277 5.22723 5.46447 5.53553C5.15616 5.84384 5.15616 6.34371 5.46447 6.65202L7.88352 9.07107L5.46447 11.4901Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnImageDelete);
export default __webpack_public_path__ + "static/media/btn_image_delete.ddd08886ba93c9e695f007bb068dc3c6.svg";
export { ForwardRef as ReactComponent };